export enum Sex {
  Female = 'F',
  Male = 'M',
}
